











import { PDFDocument } from "pdf-lib";
import {
  defineComponent,
  reactive,
  watch,
  watchEffect
} from "@vue/composition-api";

import { Document } from "@/tools/msa/models";

interface Props {
  file: File;
  document: Document;
}

interface State {
  entireFile: File | null;
  entirePdf: PDFDocument | null;
  selectedUri: string | null;
  loading: boolean;
}

export default defineComponent<Props>({
  name: "PdfView",
  props: {
    file: { type: File, required: true },
    document: { type: Object, required: true }
  },
  setup(props: Props) {
    const state = reactive<State>({
      entireFile: null,
      entirePdf: null,
      selectedUri: null,
      loading: false
    });

    watch(
      () => state.entireFile,
      file => {
        if (!file) {
          return;
        }
        file
          .arrayBuffer()
          .then(data => PDFDocument.load(data))
          .then(value => (state.entirePdf = value));
      }
    );

    watch([() => state.entirePdf, () => props.document], async (...a) => {
      if (state.entirePdf instanceof PDFDocument) {
        state.loading = false;

        const result = await PDFDocument.create();

        for (let page of await result.copyPages(
          state.entirePdf,
          props.document.pages.map(page => page.number - 1)
        ))
          result.addPage(page);

        URL.revokeObjectURL(state.selectedUri);
        state.selectedUri = URL.createObjectURL(
          new Blob([(await result.save()).buffer], { type: "application/pdf" })
        );

        state.loading = true;
      }
    });

    watchEffect(() => {
      state.entireFile = props.file;
    });

    return { state };
  }
});
